import { t as uiText } from '../i18n';
import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { fetchUserWorkspaces } from '../features/workspace/fetchUserWorkspaces';
import { hasNcgApplyPending, NCG_APPLY_PATH } from '../features/signup/ncgApplyValidation';

function sanitizeRelativePath(input: string | null): string | null {
  if (!input) return null;
  const raw = input.trim();
  if (!raw) return null;
  if (!raw.startsWith('/')) return null;
  if (raw.startsWith('//')) return null;
  if (/^[a-zA-Z][a-zA-Z0-9+.-]*:\/\//.test(raw)) return null;
  return raw;
}

const AuthRedirect: React.FC = () => {
  const { user, initializing } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    const handleRedirect = async () => {
      if (initializing) return; // 初期化中は待機

      if (user) {
        try {
          // ログイン後にリダイレクトすべきURLがあるかチェック
          const redirectPath =
            sessionStorage.getItem('redirectAfterLogin') ||
            sanitizeRelativePath(new URLSearchParams(window.location.search).get('redirect'));
          if (redirectPath) {
            // 保存されたURLを削除してリダイレクト
            sessionStorage.removeItem('redirectAfterLogin');
            navigate(redirectPath, { replace: true });
            return;
          }

          // ユーザーのワークスペース一覧を取得
          const workspaces = await fetchUserWorkspaces(user.uid);

          if (workspaces.length > 0) {
            const targetPath = `/${workspaces[0].id}`;
            navigate(targetPath, { replace: true });
          } else if (hasNcgApplyPending()) {
            navigate(NCG_APPLY_PATH, { replace: true });
          } else {
            navigate('/home', { replace: true });
          }
        } catch (error) {
          console.error('🔄 [AuthRedirect] ワークスペース取得エラー:', error);
          if (hasNcgApplyPending()) {
            navigate(NCG_APPLY_PATH, { replace: true });
          } else {
            navigate('/home', { replace: true });
          }
        }
      } else {
        navigate('/sys/login', { replace: true });
      }
    };

    handleRedirect();
  }, [user, initializing, navigate]);

  if (initializing) {
    return <div>{uiText("Loading now...")}</div>;
  }

  return null; // リダイレクトが処理されるため、何も表示しない
};

export default AuthRedirect;
